import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "global-filter-container"
}
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = {
  key: 0,
  class: "filter-site-container"
}
const _hoisted_4 = {
  key: 3,
  class: "list-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_AccordionItem = _resolveComponent("AccordionItem")!
  const _component_AccordionList = _resolveComponent("AccordionList")!
  const _component_ModalChoixSite = _resolveComponent("ModalChoixSite")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isXlsLoading || _ctx.isPdfLoading)
      ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.displayModalChoixSite)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.isUniqueSite)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_ctx.$t('intervention.non-preventive.filter')) + " ", 1),
                  _createVNode(_component_ButtonBlue, {
                    "on-click": _ctx.selectionnerSite,
                    text: _ctx.$t('bouton.choix.site'),
                    class: "button-confirm btn",
                    disabled: _ctx.tableData.length === 0 && _ctx.isLoading
                  }, null, 8, ["on-click", "text", "disabled"]),
                  _createVNode(_component_ReglePastille, { cle: "facturation.suiviFinancierChoixSite" })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Filter, {
              onSearch: _ctx.search,
              onClearFilter: _ctx.clearFilter,
              onSetCreatedDateFrom: this.setCreatedDateFrom,
              onSetCreatedDateTo: this.setCreatedDateTo,
              filter: _ctx.filter
            }, null, 8, ["onSearch", "onClearFilter", "onSetCreatedDateFrom", "onSetCreatedDateTo", "filter"])
          ]),
          _createVNode(_component_AccordionList, { class: "container-accordion" }, {
            default: _withCtx(() => [
              _createVNode(_component_AccordionItem, {
                class: "cursor-pointer",
                onClick: _ctx.displayOrHideSearch,
                onKeydown: [
                  _withKeys(_ctx.displayOrHideSearch, ["enter"]),
                  _withKeys(_withModifiers(_ctx.displayOrHideSearch, ["prevent"]), ["space"])
                ],
                tabindex: "0"
              }, {
                summary: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('facture.suivi.criteresAvances')), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Filter, {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                    onSearch: _ctx.search,
                    onClearFilter: _ctx.clearFilter,
                    onSetInterventionId: _ctx.setFilterInterventionId,
                    onComparison: _ctx.setComparison,
                    onComparisonValue: _ctx.setComparisonValue,
                    onSetType: _ctx.setType,
                    filter: _ctx.advancedFilter,
                    "status-list": _ctx.statusList,
                    "comparison-list": _ctx.comparisonList,
                    "type-intervention-list": _ctx.typeInterventionListToString,
                    "hide-header": true,
                    "hide-button": true,
                    class: "container-filter"
                  }, null, 8, ["onSearch", "onClearFilter", "onSetInterventionId", "onComparison", "onComparisonValue", "onSetType", "filter", "status-list", "comparison-list", "type-intervention-list"])
                ]),
                _: 1
              }, 8, ["onClick", "onKeydown"])
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createBlock(_component_ModalChoixSite, {
          key: 2,
          onCancel: _ctx.modalChoixSiteCancel,
          onValider: _ctx.validerSite,
          "selected-site": null,
          "selected-sites": _ctx.filter.siteList,
          "is-multi-site": true
        }, null, 8, ["onCancel", "onValider", "selected-sites"])),
    (!_ctx.displayModalChoixSite)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (!_ctx.isLoading && _ctx.tableData != null && _ctx.tableData.length !== 0)
            ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                key: 0,
                class: "export-button",
                onClick: _ctx.exportXlsSuiviFinancier,
                imgUrl: _ctx.iconeXls,
                title: _ctx.$t('list.export')
              }, null, 8, ["onClick", "imgUrl", "title"]))
            : _createCommentVNode("", true),
          (!_ctx.isLoading && _ctx.tableData != null && _ctx.tableData.length !== 0)
            ? (_openBlock(), _createBlock(_component_ReglePastille, {
                key: 1,
                cle: "facturation.suiviFinancierExport"
              }))
            : _createCommentVNode("", true),
          (_ctx.tableData != null && _ctx.tableData.length === 0 && _ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                key: 2,
                class: "loader"
              }))
            : (_openBlock(), _createElementBlock("div", {
                key: 3,
                onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                ref: "content",
                class: _normalizeClass(["datatable", {'datatable-smaller': _ctx.accordionOpen}])
              }, [
                _createVNode(_component_DataTable, {
                  tableHeader: _ctx.tableHeader,
                  tableData: _ctx.tableData,
                  isLoading: _ctx.isLoading,
                  noDataText: _ctx.$t('facture.suivi.noData'),
                  "stop-propa-on-pdf": true,
                  onDownloadPdf: _ctx.downloadPdf,
                  onSort: _ctx.doSort,
                  onSelect: _ctx.downloadPdf
                }, null, 8, ["tableHeader", "tableData", "isLoading", "noDataText", "onDownloadPdf", "onSort", "onSelect"])
              ], 34))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}